import { Component, Input, OnInit } from "@angular/core";
import { BreadcrumbUtilService } from "./breadcrumb-util.service";

@Component({
  selector: 'ngx-breadcrumb-util',
  templateUrl: './breadcrumb-util.component.html',
  styleUrls: ['./breadcrumb-util.component.scss']
})
export class BreadcrumbUtilComponent implements OnInit {
  @Input() pageTitle: string = '';
  breadcrumbs: { label: string; link?: string }[] = [];

  constructor(private breadcrumbUtilService: BreadcrumbUtilService) {}

  ngOnInit(): void {
    this.breadcrumbUtilService.breadcrumbs$.subscribe((breadcrumbs) => {
      this.breadcrumbs = breadcrumbs;
    });
  }

  navigate(link?: string): void {
    if (link) {
      // You can implement your navigation logic here, for example, using Angular Router
      console.log('Navigate to:', link);
    }
  }
}
